var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("a-result", {
    attrs: {
      status: "500",
      title: "401",
      "sub-title": _vm.subTitle || _vm.$t("layout.error-401"),
    },
    scopedSlots: _vm._u([
      {
        key: "extra",
        fn: function () {
          return [
            _c(
              "a-button",
              { attrs: { type: "primary" }, on: { click: _vm.toHome } },
              [_vm._v(" 返回首页 ")]
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }